import BlogBanner from "@/src/modules/blog/blogBanner";
import DashboardLayout from "@/src/components/layout/DashboardLayout";
import Progressbar from "@/src/components/loading";
import { blogApiService } from "@/src/lib/api-services/blogApiServices";

import { useState } from "react";
import BlogList from "@/src/modules/blog/blogList";

BlogListPage.getLayout = (page) => <DashboardLayout>{page}</DashboardLayout>;

export default function BlogListPage({ data: initialData }) {
    const [page, setPage] = useState(1);

    // Update page data manually on page change
    const [data, setData] = useState(initialData);

    const rowsPerPage = 30;

    const totalPages = Math.ceil(
        (data?.data?.[0]?.totalRecords || 0) / rowsPerPage
    );

    const handlePageChange = async (newPage) => {
        if (newPage < 1 || newPage > totalPages) return;
        setPage(newPage);
        try {
            const response = await blogApiService.getBlogLists(newPage);
            setData(response);
        } catch (error) {
            console.error("Failed to fetch data:", error);
        }
    };

    return (
        <div className="bg-gray-100">
            <BlogBanner />
            <div className="md:py-10 py-5 max-w-6xl mx-auto">
                <div className="grid gap-6 sm:grid-cols-4 md:grid-cols-3 grid-cols-1">
                    {data?.data?.length > 0 &&
                        data.data.map((item, index) => (
                            <BlogList key={index} item={item} />
                        ))}
                </div>

                {/* Custom Pagination */}
                {totalPages > 1 && (
                    <div className="flex justify-center md:py-10 py-5">
                        <div className="flex items-center gap-2 bg-white shadow-md px-4 py-2 rounded-lg">
                            <button
                                onClick={() => handlePageChange(page - 1)}
                                disabled={page === 1}
                                className="px-3 py-1 rounded-md border border-gray-300 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                Prev
                            </button>

                            {[...Array(totalPages)].map((_, i) => {
                                const pageNumber = i + 1;
                                return (
                                    <button
                                        key={pageNumber}
                                        onClick={() =>
                                            handlePageChange(pageNumber)
                                        }
                                        className={`px-3 py-1 rounded-md border ${
                                            page === pageNumber
                                                ? "bg-primary text-white border-primary"
                                                : "border-gray-300 hover:bg-gray-100"
                                        }`}
                                    >
                                        {pageNumber}
                                    </button>
                                );
                            })}

                            <button
                                onClick={() => handlePageChange(page + 1)}
                                disabled={page === totalPages}
                                className="px-3 py-1 rounded-md border border-gray-300 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                Next
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export async function getServerSideProps() {
    let initialData = null;

    try {
        initialData = await blogApiService.getBlogLists(1);
    } catch (error) {
        console.error("Failed to fetch initial data:", error);
    }

    return {
        props: {
            data: {
                ...(initialData || {}),
                seoTitle: "Blogs | House of Diagnostics | HOD",
                seoDescription:
                    "HOD blogs keep you updated about latest health trends. It also gives an insight into the new technology and informative articles on various health conditions.",
                routerPath: "blog",
            },
        },
    };
}
